export const SET_FINISHED = 'FINISHED_SET_FINISHED';

interface SetFinishedAction {
    type: typeof SET_FINISHED,
    payload: boolean
}

export type FinishedActionTypes = SetFinishedAction;